<template>
  <div class="phone-number-wrapper">
    <form @submit.prevent="phoneNumberChangeStatus">
      <label class="input-container medium-9 columns settings-item">
        <div class="mb-2 text-xs font-medium flex flex-row wrapper">
          <span>{{
            $t('INBOX_MGMT.ADD.EVOLUTION_API.PHONE_NUMBER.LABEL')
          }}</span>
          <channel-badge-status
            :status-text="badgeStatusText"
            :active="isPhoneNumberLinked"
          />
        </div>
        <input type="text" :value="value" disabled />
      </label>
      <div class="medium-12 columns section--button">
        <woot-submit-button
          type="submit"
          :button-text="linkButtonText"
          :loading="uiFlags.isCreating"
        />
      </div>
    </form>
  </div>
</template>

<script>
import ChannelBadgeStatus from './ChannelBadgeStatus.vue';
import { mapGetters } from 'vuex';
export default {
  components: {
    ChannelBadgeStatus,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    isPhoneNumberLinked: {
      type: Boolean,
      default: false,
    },
    phoneNumberChangeStatus: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
    linkButtonText() {
      return this.isPhoneNumberLinked
        ? this.$t('INBOX_MGMT.ADD.EVOLUTION_API.BUTTONS.UNLINK_BUTTON')
        : this.$t('INBOX_MGMT.ADD.EVOLUTION_API.BUTTONS.LINK_BUTTON');
    },
    badgeStatusText() {
      return this.isPhoneNumberLinked
        ? this.$t('INBOX_MGMT.ADD.EVOLUTION_API.LINKED_NUMBER')
        : this.$t('INBOX_MGMT.ADD.EVOLUTION_API.UNLINKED_NUMBER');
    },
  },
};
</script>
<style lang="scss" scoped>
.phone-number-wrapper {
  margin-bottom: var(--space-normal);
}
.wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: end;
  margin-bottom: var(--space-micro);
}
</style>
